import { createAsyncThunk } from "@reduxjs/toolkit";
import notificationApi from "app/api/notification";

const NOTIFICATION = "notification";

export const getUnprocessPrifeClaimNotification = createAsyncThunk(
  `${NOTIFICATION}/getUnprocessPrifeClaimNotification`,
  async (_, thunkApi) => {
    return notificationApi
      .getUnprocessPrifeClaimNotification()
      .then((response) => response.data)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

export const getUnprocessClaimNotification = createAsyncThunk(
  `${NOTIFICATION}/getUnprocessClaimNotification`,
  async (_, thunkApi) => {
    return notificationApi
      .getUnprocessClaimNotification()
      .then((response) => response.data)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

export const getUnprocessMasterListNotification = createAsyncThunk(
  `${NOTIFICATION}/getUnprocessMasterListNotification`,
  async (_, thunkApi) => {
    return notificationApi
      .getUnprocessMasterListNotification()
      .then((response) => response.data)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

export const getUnprocessShippingOrderNotification = createAsyncThunk(
  `${NOTIFICATION}/getUnprocessShippingOrderNotification`,
  async (_, thunkApi) => {
    return notificationApi
      .getUnprocessShippingOrderNotification()
      .then((response) => response.data)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

export const getPurchaseOrderNotification = createAsyncThunk(
  `${NOTIFICATION}/getPurchaseOrderNotification`,
  async (_, thunkApi) => {
    return notificationApi
      .getPurchaseOrderNotification()
      .then((response) => response.data)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);
